import { chatProviders, emailProviders, smsProviders, pushProviders } from './channels';
export const providers = [...emailProviders, ...smsProviders, ...chatProviders, ...pushProviders];
